import React, { useState, useEffect } from 'react';
import './Hero.css';

const heroSlides = [
  { image: '/images/hero/hero-1.jpg' },
  { image: '/images/hero/hero-2.jpg' },
  { image: '/images/hero/hero-3.jpg' },
  { image: '/images/hero/hero-4.jpg' },
];

const Hero: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <section id="home" className="hero-section">
      {/* Background Slides */}
      <div className="hero-slides">
        {heroSlides.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          />
        ))}
      </div>

      {/* Overlay */}
      <div className="hero-overlay" />

      {/* Content */}
      <div className="hero-content">
        <div className="hero-badge">
          <i className="fas fa-child"></i>
          <span>4-6 Yaş Grubu</span>
        </div>
        <h1 className="hero-title">
          Sevgiyle Büyüyen,<br />
          Kur'an'la Güçlenen Nesiller
        </h1>
        <p className="hero-tagline">Kur'an Işığında İlk Adımlar</p>
        <p className="hero-description">
          Çocuklarımızı, Peygamberimizin ahlakıyla tanıştırıyor; Kur'an'ın nuruyla
          aydınlanan, hayata güvenle hazırlanan minikler yetiştiriyoruz.
        </p>
        <div className="hero-buttons">
          <a href="tel:05389466443" className="hero-button hero-button-primary">
            <i className="fas fa-phone-alt"></i>
            Hemen Ara
          </a>
          <a href="#contact" className="hero-button hero-button-secondary">
            <i className="fas fa-calendar-check"></i>
            Randevu Al
          </a>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="hero-indicators">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            className={`hero-indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Scroll Down Indicator */}
      <div className="hero-scroll-indicator">
        <i className="fas fa-chevron-down"></i>
      </div>
    </section>
  );
};

export default Hero;
